import thdCustomer from '@thd-olt-global/thd-customer';
import { api } from './base';
import { getTMXSessionID } from '../utils';

export function signoutActivityApi(smSessionId) {
  const sessionId = `${thdCustomer?.userID}:${smSessionId}`;
  const tmxProfileId = getTMXSessionID();
  const activityRequest = {
    method: 'post',
    url: '/customer/auth/v1/session/logout',
    headers: {
      Authorization: thdCustomer.jwt
    },
    data: { sessionId, tmxProfileId }
  };

  return api(activityRequest)
    .then((res) => {
      return res;
    })
    .catch(() => {
      return null;
    });
}
